module.exports = "/_next/static/images/Hero@2x-e7dc4c046cfb3177fe82a79c3ac481ce.png";